import React, { useEffect, useState } from "react";
import "./LogsPage.scss";
import Plot from "react-plotly.js";

interface Props {
    user: string[];
    gap: number[];
}

export default function LastActivityPlot(props: Props) {
    var data = [{
        x: props.user,
        y: props.gap,
        type: 'bar',
        transforms: [{type: 'sort', target: 'y', order: 'ascending'}]
    }];
    var layout = {
        title: {
            text: 'Days from Last Activity',
            font: {
                size: 20
            }
        },
        xaxis: {
            title: 'User'
        },
        yaxis: { 
            title: 'Days from Last Activity' 
        },
        margin: { l: 50, r: 50, t: 50, b: 150 }
    };

    return (
        <div className="chart-container pie-chart">
            <Plot data={data as any} layout={layout} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
